import type { ApiObject } from "@rudderstack/analytics-js";

import { analyticsService } from "../analytics";
import type { SingularEventArgs, SingularEventName } from "./types";

/**
 * Mirrors a Singular event to a generic `SingularEvent` analytics breadcrumb.
 * Shared by the web and native `SingularService` so the two cannot drift. See
 * `lib/singular/README.md`.
 */
export function trackSingularEvent(
  event: SingularEventName,
  skipForInternalUser: boolean,
  args?: SingularEventArgs,
): void {
  analyticsService.trackEvent(
    "SingularEvent",
    args
      ? // Singular's SerializableValue args are RudderStack-serializable at
        // runtime; the static types diverge (nested arrays), so bridge to
        // ApiObject for the analytics payload.
        { event, skipForInternalUser, args: args as ApiObject }
      : { event, skipForInternalUser },
  );
}
